<template>
 <div class="mt-3">
   <div :class="styletable.row" v-if="custDetail.shipment_type !== 'BARGE'
                                      && custDetail.shipment_type !== 'LCT'">
     <div :class="styletable.col1">Product Type</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{getProductType(custDetail.product_class)}}</div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">HS Code</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.hs_code || '-'}}</div>
   </div>

   <div :class="styletable.row" v-if="custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
     <div :class="styletable.col1">Ready to Load Date</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.load_date ? getDateFormat2(custDetail.load_date) : '-'}}</div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">Commodities</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2" v-if="custDetail.shipment_type === 'BARGE'
                                      || custDetail.shipment_type === 'LCT'">
                                      {{custDetail.product_type}}
                                    </div>
     <div :class="styletable.col2" v-else>{{custDetail.description}}</div>
   </div>

   <div :class="styletable.row" v-if="custDetail.product_class === 'DG'">
     <div :class="styletable.col1">UN Number</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{custDetail.un_number || '-'}}</div>
   </div>

   <div :class="styletable.row">
     <div :class="styletable.col1">PO Number</div>
     <div :class="styletable.col3">:</div>
     <div :class="styletable.col2">{{mixinConvertSymbol(custDetail.po_number, '&') || '-'}}</div>
   </div>

 </div>
</template>
<script>
import mixin from '@/mixin/getters/shipment-details'
import mixinFunctions from '@/mixin/getters/functions'
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  name: 'AddressDetails',
  props: {
    typeRequest: String,
    custDetail: Object,
    isLoading: Boolean
  },
  mixins: [mixin, mixinFunctions, mixinDateTime],
  data () {
    return {
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md pl-1 textcolor textbold',
        col3: 'col-md-0'
      }
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/tabs-detail/ProductDetails.vue